import _system from '../core/core--object-system';

const libraryUtils = {};
const add = libraryUtils;

add.leftPad = function leftPad(str, length = 70) {
    return `➜ ${' '.repeat(length - str.length)}${str}`;
};

add.uniqueId = function() {
    function generateId() {
        const id = _system.id.prefix + _system.id.count;
        ++_system.id.count;
        if ($(`#${id}`).length) generateId(); // Double check it doesn't exsit
        // console.log('Unique ID', id);
        return id;
    }
    return generateId();
};

add.once = function once(fn, context) {
    let result;

    return function() {
        if (fn) {
            result = fn.apply(context || this, arguments);
            fn = null;
        }

        return result;
    };
};

// Checks for desired state at intervals
// Used to detect if page was dynamically updated
add.poll = function poll(fn, timeout, interval) {
    const endTime = Number(new Date()) + (timeout || 2000);
    interval = interval || 100;

    const checkCondition = function(resolve, reject) {
        // If the condition is met, we're done!
        const result = fn();
        if (result) {
            resolve(result);
        }
        // If the condition isn't met but the timeout hasn't elapsed, go again
        else if (Number(new Date()) < endTime) {
            setTimeout(checkCondition, interval, resolve, reject);
        }
        // Didn't match and too much time, reject!
        else {
            reject(new Error(`timed out for ${fn}: ${arguments}`));
        }
    };

    return new Promise(checkCondition);
};

add.isBrowser = function isBrowser(browserName) {
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    const isFirefox = typeof InstallTrigger !== 'undefined';

    const chrome = isChrome ? 'chrome' : false;
    const firefox = isFirefox ? 'firefox' : false;

    if (browserName === firefox) return true;
    if (browserName === chrome) return true;
    return false;
};

export default libraryUtils;
